import { SelectInputOptionWithDynamicLabel } from '@accredible-frontend-v2/new-components/select-input';
import { inject, Injectable } from '@angular/core';
import { AccredibleLanguageService } from '../language.service';

export type IndustryTranslation = SelectInputOptionWithDynamicLabel;

export const ALL_JOBS_VALUE = 'all-jobs';

export const INDUSTRY_CODES = [
  ALL_JOBS_VALUE,
  'customer-services-jobs',
  'teaching-jobs',
  'other-general-jobs',
  'accounting-finance-jobs',
  'retail-jobs',
  'manufacturing-jobs',
  'hospitality-catering-jobs',
  'healthcare-nursing-jobs',
  'trade-construction-jobs',
  'domestic-help-cleaning-jobs',
  'creative-design-jobs',
  'logistics-warehouse-jobs',
  'hr-jobs',
  'pr-advertising-marketing-jobs',
  'social-work-jobs',
  'travel-jobs',
  'energy-oil-gas-jobs',
  'maintenance-jobs',
  'scientific-qa-jobs',
  'graduate-jobs',
  'engineering-jobs',
  'part-time-jobs',
  'sales-jobs',
  'admin-jobs',
];

export const INDUSTRIES_TRANSLATION_KEY = 'industries';

@Injectable({
  providedIn: 'root',
})
export class IndustriesService {
  private readonly _language = inject(AccredibleLanguageService);

  getIndustries(): IndustryTranslation[] {
    return INDUSTRY_CODES.map((code) => ({
      value: code,
      name: this._language.selectTranslate(`industries.${code}`),
    }));
  }
}
